import { Action, createReducer, on } from '@ngrx/store';
import { GeoState, initialGeoState } from '../model/geo.model';
import * as GeoActions from '../action/geo.action';

// Load initial state from localStorage
function loadInitialState(): GeoState {
  // Check if we're in browser environment
  if (typeof window !== 'undefined' && typeof localStorage !== 'undefined') {
    try {
      const saved = localStorage.getItem('geo-state');
      if (saved) {
        const parsed = JSON.parse(saved);
        // Check if cache is still valid
        const now = Date.now();
        if (parsed.lastChecked && (now - parsed.lastChecked) < parsed.cacheExpiry) {
          return { ...initialGeoState, ...parsed };
        }
      }
    } catch (error) {
      // Silently fail and return initial state
    }
  }
  return initialGeoState;
}

// Save state to localStorage
function saveToLocalStorage(state: GeoState) {
  // Check if we're in browser environment
  if (typeof window !== 'undefined' && typeof localStorage !== 'undefined') {
    try {
      localStorage.setItem('geo-state', JSON.stringify(state));
    } catch (error) {
      // Silently fail
    }
  }
}

const _geoReducer = createReducer(
  initialGeoState,
  on(GeoActions.checkGeoLocation, (state) => {
    // Load from localStorage only when action is dispatched (in browser)
    const initialState = state.lastChecked ? state : loadInitialState();
    return {
      ...initialState,
      loading: true,
      error: null
    };
  }),
  on(GeoActions.geoLocationSuccess, (state, { isRegulated, country }) => {
    const newState = {
      ...state,
      isRegulated,
      country,
      loading: false,
      error: null,
      lastChecked: Date.now()
    };
    saveToLocalStorage(newState);
    return newState;
  }),
  on(GeoActions.geoLocationFailure, (state, { error }) => {
    const newState = {
      ...state,
      loading: false,
      error,
      // Default to regulated for safety
      isRegulated: true,
      lastChecked: Date.now()
    };
    saveToLocalStorage(newState);
    return newState;
  }),
  on(GeoActions.loadFromCache, (state) => state)
);

export function geoReducer(state: GeoState | undefined, action: Action) {
  return _geoReducer(state, action);
}